<template>
  <div class="container-fluid-intropage">
    <div class="container-fluid p-0 cover-story">
      <img src="/especiales/noticias/2022/jaimejarrin/images/cover-jaime-jarrin.png" alt="" width="100%">
    </div>
    <div class="container-meta">
      <div class="container pt-3 pb-3">
        <div class="row justify-content-center">
          <div class="col-12 col-md-9 text-center">
            <div class="mb-3">
              <img width="200px" src="@/assets/pride.png" alt="">
            </div>
            <h1 class="name">Jaime Jarrín: la leyenda de los Dodgers que enseñó a los hispanos a amar el beisbol</h1>
            <div class="description">
              <h2 class="description__title"> La voz gruesa, pasional y potente dejó de ser únicamente la del cronista oficial en español de los Dodgers para convertirse en un símbolo de identidad, cultura y liderazgo para la comunidad hispana en Estados Unidos. Esta es su historia.</h2>
            </div>
            <div class="mt-3">
              <SharingOptions />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .container-fluid-intropage {
    position: relative;
    background:  #000000;

    .cover-story {
      width: 100%;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
        min-height: 100vh;
        object-fit: cover;
        object-position: top;

        @media(max-width:560px){
          height: 45vh;
          min-height: 45vh;
          max-height: 45vh;
        }
      }
    }
  }

  .container-meta {
    position: absolute;
    width: 100%;
    bottom: 0;

    @media(max-width:560px){
      position: relative;
    }
  }
</style>

<script>
  import SharingOptions from '@/components/SharingOptions.vue';

	export default {
    name: "IntroPage",
    components: {
      SharingOptions
    }
  }
</script>